import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import GButton from "components/ui/button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  getItemTags,
  addTagToItem,
  getTagsOfItem,
} from "../../services/itemTagsService";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
const AddTagsModal = ({ onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const id = useParams();
  const { handleSubmit, setValue } = useForm();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });

  const itemTags = useSelector((state) => state.tagsOfItem);

  useEffect(() => {
    dispatch(getItemTags());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.inventory.add_tag")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.TagId = values.TagId?.TagId;
              values.InventoryItemId = id.itemId;
              values.UserId = localStorage.getItem("userId");
              if (values.TagId === undefined) {
                toast2({
                  description: t("pages.DailyRestrictions.searchvalidation"),
                });
              } else {
                dispatch(addTagToItem(values))
                  .unwrap()
                  .then((_) => {
                    toast({ description: t("pages.items.itemtag_created") });
                    dispatch(getTagsOfItem(id.itemId));
                    onClose();
                  });
              }
            })}
          >
            <Stack spacing={6}>
              <MultiSelect
                title={t("pages.inventory.tags")}
                data={
                  itemTags.data &&
                  itemTags.data.map((el) => ({
                    ...el,
                    label: el.TagName,
                    value: el.TagGroupId,
                  }))
                }
                isMulti={false}
                isRequired={true}
                onChange={(e) => setValue("TagId", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("pages.inventory_item_details.apply")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={itemTags.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={itemTags.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default AddTagsModal;
